import { useMemo } from "react";

import FieldUtils from "../../../utils/FieldUtils";
import ThumbnailAvatar from "./ThumbnailAvatar";
import ThumbnailLogo from "./ThumbnailLogo";

interface Props {
  record: Record<string, any> | undefined;
  imageKey: string | undefined; // The key of the image field in the record. Example: "ProfileImage"
  mode?: "Logo" | "Avatar" | null;
  size?: "xs" | "sm" | "md" | "lg";
  className?: string;
  withBorder?: boolean;
}

const ThumbnailWidget = ({
  record,
  imageKey,
  mode = "Logo",
  size = "sm",
  className,
  withBorder = true,
}: Props) => {
  mode = mode || "Logo";
  const imageRecord = imageKey ? record?.[imageKey] : undefined;
  const color = record?._Color;

  const initials = useMemo(() => {
    return FieldUtils.getInitials(record);
  }, [imageRecord?.URL, imageRecord?.File, size, record, mode]);

  if (mode === "Logo") {
    return (
      <ThumbnailLogo
        imageRecord={imageRecord}
        className={className}
        size={size}
        initials={initials}
        color={color}
        withBorder={withBorder}
      />
    );
  }

  if (mode === "Avatar") {
    return (
      <ThumbnailAvatar
        imageRecord={imageRecord}
        initials={initials}
        size={size}
        color={color}
        className={className}
        withBorder={withBorder}
      />
    );
  }

  return null;
};

export default ThumbnailWidget;
